import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_8 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.8 Case 8</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="A"
          assessmentName="challenge_case_8"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 8. This is a positive case.
                Beginning at the level of the occipital lobes, intense focal
                uptake is identified in the right occipital region, seen here.
                This activity, which is within the gray matter, exceeds that of
                the activity in the surrounding white matter. This focal intense
                activity alone would make this scan positive. However, let’s
                continue to review the remainder of the scan.
              </p>
              <p>
                As we move superiorly and enter into the temporal lobes, seen here, there is loss of gray-white contrast bilaterally. Distinct white matter tracts are not identifiable on either side. As we continue to move upwards, this pattern continues and is also seen in the occipital regions, seen here. Therefore, there is loss of gray-white contrast in both the temporal and occipital regions. As we enter into the frontal cortices, seen here, distinct white matter tracts are not identifiable on the left or the right. There is increased activity in the gray matter, extending to the cortical rim, and there is loss of gray-white contrast bilaterally.
              </p>
              <p>
                As we enter into the parietal region, normally white matter
                tracts are delineated, moving from the front of the brain to the
                back of the brain on either side. However, these white matter
                tracts are not identified on this scan. In addition, increased
                activity is seen in the gray matter, extending to the cortical
                rim, on the left as well as on the right within the parietal
                regions.
              </p>
              <p>
                As we enter into the medial parietal regions, which includes the area of the precuneus, intense activity is seen within the gray matter. This activity causes loss of gray-white contrast. The remainder of the slices also show loss of gray-white contrast. As there is diffuse loss of gray-white contrast in all regions, as well as focal intense uptake within the right occipital region, this scan is positive. If you called this case negative, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-7"
          nextLesson="/module-4/module-4-1-9"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1985384898&entry_id=1_ynh05uqf&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_ynh05uqf"
        />
      </main>
    </div>
  );
};

export default Module_4_1_8;
